import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=4194b1d4"
import script from "./AddToCart.ts?vue&type=script&lang=ts&external"
export * from "./AddToCart.ts?vue&type=script&lang=ts&external"
import style0 from "./AddToCart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports